export var VERSION = '2.11.7';
//# sourceMappingURL=version.js.map